import { render, staticRenderFns } from "./TopTenClients.vue?vue&type=template&id=00855817&"
import script from "./TopTenClients.vue?vue&type=script&lang=js&"
export * from "./TopTenClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports